module.exports = __webpack_public_path__ + "static/img/CY.0b49fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CY.png
// module id = G2/E
// module chunks = 18